import { Typography } from "@mui/material";
import { isFilePayload } from "@pubnub/react-chat-components";

import type { MessageEnvelope } from "@pubnub/react-chat-components";

interface Props {
  userIsAuthor: boolean;
  message: MessageEnvelope;
}

export function MessageTextDisplay(props: Props) {
  const { userIsAuthor, message } = props;
  if (isFilePayload(message.message)) {
    return null;
  }

  return (
    <Typography variant="body1" textAlign={userIsAuthor ? "right" : "left"}>
      {message.message.text ?? ""}
    </Typography>
  );
}
